// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-85b31ffc]{background:rgba(180,144,143,.31);-webkit-backdrop-filter:saturate(180%) blur(10px);backdrop-filter:saturate(180%) blur(10px);border-radius:10px}.number[data-v-85b31ffc]{background:#3d3d3d;border-radius:4px}.number span[data-v-85b31ffc]{color:#fff}span.number-label[data-v-85b31ffc]{color:#c0a096}", ""]);
// Exports
module.exports = exports;
